import {FornecedorPesquisa} from "@components/fornecedores/FornecedorPesquisa.js";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import type {IFornecedor} from "@models/fornecedores/fornecedor.js";
import {Save} from "@mui/icons-material";
import {Button, Grid, TextField,} from "@mui/material";
import dayjs from "dayjs";
import React, {useEffect, useMemo, useState} from "react";
import {IRecurso} from "@models/recurso/IRecurso.ts";
import {RecursoPesquisa} from "@components/recurso/RecursoPesquisa.tsx";
import {MoneyInputEntry} from "@shared/specialComponents/InputEntry.tsx";
import {IContrato} from "@models/contratos/contrato.ts";
import {ICreateContratoDto} from "@components/contratos/models/ICreateContratoDto.ts";
import {useContrato} from "@components/contratos/hooks/useContrato.tsx";
import {DefaultDatePicker} from "@shared/custom/DefaultDatePicker.tsx";

interface CreateContratoPageProps {
    recursoId?: number,
    onCreate?: (contrato: IContrato) => void
}

export const CreateContratoPage: React.FC<CreateContratoPageProps> = (props) => {
    const {createAlertFromResponse} = useAlert()
    const {createContrato} = useContrato()

    const [fornecedorSelecionado, setFornecedorSelecionado] = useState<IFornecedor | undefined>(undefined)

    const [dados, setDados] = useState<ICreateContratoDto>({
        nome: ""
    })

    const [recursoSelecionada, setRecursoSelecionada] = useState<IRecurso | undefined>(undefined)

    const sendHandler = () => {
        createContrato(dados).then(x => {
            createAlertFromResponse(x)
            if (x.status == 'Success') {
                if (props.onCreate) props.onCreate(x.items)
            }
        })
    }

    const changeIdentificacaoHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDados({...dados, nome: e.target.value})
    }

    const changeDescricaoHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value != '' ? e.target.value : undefined
        setDados({...dados, descricao: value})
    }

    useEffect(() => {
        setDados({...dados, recursoId: recursoSelecionada?.id})
    }, [recursoSelecionada])

    useEffect(() => {
        setDados({...dados, fornecedorId: fornecedorSelecionado?.id})
    }, [fornecedorSelecionado])

    useEffect(() => {
        if (props.recursoId)
            setDados({...dados, recursoId: props.recursoId})
    }, [props]);

    const dataInicioValid = useMemo(() => {
        if (dados.dataInicio == null) return false
        const dt = dayjs(dados.dataInicio)

        return (dados.dataFim == null || dt.isBefore(dados.dataFim)) && dt.isAfter(dayjs().add(-1, 'day'))
    }, [dados.dataInicio, dados.dataFim]);

    const nomeValid = useMemo(() => {
        return dados.nome.length >= 5;
    }, [dados.nome])

    const allValid = useMemo(() => {
        return (nomeValid && dataInicioValid)
    }, [nomeValid, dataInicioValid])

    return (
        <Grid container>
            <Grid size={12}>
                <Grid container justifyContent={'space-between'}>
                    <Grid/>
                    <Grid>
                        <Button disabled={!allValid}
                                onClick={sendHandler}
                                variant="outlined"
                                color={'success'}
                                endIcon={<Save/>}>
                            Salvar
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={12}>
                <TextField value={dados.nome ?? ''}
                           variant={'filled'}
                           required
                           error={!nomeValid}
                           fullWidth
                           label="Identificação do contrato"
                           onChange={changeIdentificacaoHandler}/>
            </Grid>
            <Grid size={12}>
                <TextField label={'Descrição'}
                           fullWidth
                           value={dados?.descricao ?? ''}
                           variant={'filled'}
                           onChange={changeDescricaoHandler} multiline/>
            </Grid>
            <Grid size={12}>
                <RecursoPesquisa disabled={props.recursoId != null} onItemSelected={setRecursoSelecionada}/>
            </Grid>
            <Grid size={12}>
                <FornecedorPesquisa onItemSelected={setFornecedorSelecionado}/>
            </Grid>
            <Grid size={12}>
                <DefaultDatePicker label={'Data de início'}
                                   slotProps={{
                                       textField: {
                                           required: true,
                                           error: !dataInicioValid,
                                       },
                                       actionBar: {actions: ['clear', 'today']},

                                   }}
                                   value={dados.dataInicio != null && dayjs(dados.dataInicio) || undefined}
                                   onChange={(e) => {
                                       setDados({...dados, dataInicio: e ?? undefined})
                                   }}/>
                <DefaultDatePicker label={'Data de fim'}
                                   value={dados.dataFim != null && dayjs(dados.dataFim) || undefined}
                                   onChange={(e) => {
                                       setDados({...dados, dataFim: e ?? undefined})
                                   }}/>
            </Grid>
            <Grid size={12}>
                <MoneyInputEntry label={'Valor (max:' + `${recursoSelecionada?.valor})`}
                                 textFieldProps={{variant: 'filled'}}

                                 value={dados?.valor ?? 0}
                                 onChange={(e) => {
                                     setDados({...dados, valor: e || 0})
                                 }}/>
            </Grid>
        </Grid>
    )
}